import type { AxiosError } from 'axios';

function validationErrorsFromResponse(error: AxiosError<any> | null | undefined) {
    return error?.response?.data?.validation ?? {};
}

export default validationErrorsFromResponse;
